module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAMAAACDd7esAAAAUVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////8IN+deAAAAGnRSTlMA+dappZuObkEYCgf07enAuZSFXFdWTD0xElFg/dkAAABFSURBVAjXfU1HDgAhEHLsq9ubyv8faknmKhcIoYg5svIsF0VHZx9FsFjfJo38oiN6uq0hr53ciBYN4ObeuZnAI79N88MKjjkCDNaI9yYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/check-white.png
// module id = 957
// module chunks = 5